const firebaseConfig = {
    apiKey: "AIzaSyAfoikNG1od8i3XDLAexuBMhmhoyma8y2Q",
    authDomain: "healthcare-related-websi-e641f.firebaseapp.com",
    projectId: "healthcare-related-websi-e641f",
    storageBucket: "healthcare-related-websi-e641f.appspot.com",
    messagingSenderId: "330458222381",
    appId: "1:330458222381:web:473ee0dbeb0ff9e5c60da4"
};
export default firebaseConfig;